import React, { useState } from "react";
import { Form, Modal } from "react-bootstrap";

export function ImportFromExcel({
  title,
  downloadTemplate,
  importFile,
  showDialog,
  closeDialog
}) {
  const [file, setFile] = useState();

  return (
    <Modal
      show={showDialog}
      onHide={closeDialog}
      aria-labelledby=""
    >
      <Modal.Header className="justify-content-center" closeButton>
        <Modal.Title id="">{title}</Modal.Title>
      </Modal.Header>

      <Form onSubmit={e => {
        e.preventDefault();
        importFile(file);
      }}>
        <Modal.Body>
          <div className="text-center">
            <input type="file" accept=".xlsx" onChange={e => setFile(e.target.files[0])} />
          </div>          
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button
            type="button"
            className="btn btn-sm btn-info"
            onClick={downloadTemplate}
          >
            Şablon İndir
          </button>
          <button
            type="submit"
            className="btn btn-sm btn-primary"
          >
            Yükle
          </button>
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={closeDialog}
          >
            Vazgeç
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}